/**
 * 档案管理 用能结构
 */
<template>
	 <!-- 面包屑导航 -->
	<div class="container">
    <div style="border-bottom: 4px solid #f4f4f4;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">档案管理</el-breadcrumb-item>
        <el-breadcrumb-item>用能结构</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 管理员确认 对话框 -->
    <el-dialog  title="管理员授权" :visible.sync="gVisible" width="420px" :close-on-click-modal="false">

      <el-form label-width="65px" :model="checkForm" :rules="cRules" ref="geditForm">

        <el-form-item label="账号：" prop="username">
          <el-input size="small" style="width:240px" v-model="checkForm.username" placeholder="请输入管理员账号"></el-input>
        </el-form-item>

        <el-form-item label="密码：" prop="password" >
          <el-input type="password" size="small" style="width:240px"  placeholder="请输入管理员密码" v-model="checkForm.password"></el-input>
        </el-form-item>
      </el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="mini" @click="gVisible = false">取 消</el-button>
    		<el-button size="mini" type="primary" @click="checkSwitch" :loading="loadSwitch">确 定</el-button>
    	</div>
    </el-dialog>



		<!-- 新增，编辑能源 对话框 -->
		<el-dialog  :title="'远程拉合闸'+ mName" :visible.sync="switchVisible" width="420px" :close-on-click-modal="false">

      <el-form label-width="65px" :model="switchForm" :rules="sRules" ref="seditForm">
        <el-form-item label="状态：">
          <el-tag size="small" type="success" v-if="isRun">运行中</el-tag>
          <el-tag size="small" type="danger" v-if="!isRun">断开</el-tag>
        </el-form-item>
        <el-form-item label="操作：">
          <el-radio-group v-model="switchForm.switchType">
            <el-radio label="1">拉闸</el-radio>
            <el-radio label="2">合闸</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="密码" prop="passWord">
          <el-input type="password" size="small" style="width:240px" v-model="switchForm.passWord"></el-input>
        </el-form-item>
        <!-- <el-form-item label="密级：" prop="passWord" >

          <el-select v-model="switchForm.passWord"  size="small" style="width:240px" placeholder="请选择密级">
            <el-option label="02" value="02"></el-option>
            <el-option label="03" value="03"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="switchVisible = false">取 消</el-button>
				<el-button size="mini" type="primary" @click="saveSwitch" :loading="loadSwitch">确 定</el-button>
			</div>
		</el-dialog>


		<!-- 新增，编辑 计量单位 -->
		<el-dialog :title="jltitle" :visible.sync="deitJl" width="82%" :close-on-click-modal="false">
			<el-form :model="jlEditParmater" ref="editForm" label-width="130px" label-position="left" :rules="rules">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="计量点名称" prop="meterPointName">
							<el-input size="small" v-model="jlEditParmater.meterPointName"></el-input>
						</el-form-item>
						<el-form-item label="计量点地址" prop="meterPoint">
							<el-input size="small" v-model="jlEditParmater.meterPoint"></el-input>
						</el-form-item>
            <el-form-item label="合同编号" prop="contractNo">
							<el-input size="small" v-model="jlEditParmater.contractNo"></el-input>
						</el-form-item>

            <el-form-item label="通信速率">
            	<el-input size="small" v-model="jlEditParmater.communicationRate"></el-input>
            </el-form-item>

						<!-- <el-form-item label="计量点类别" prop="meterType">
							<el-select size="small" v-model="jlEditParmater.meterType" placeholder="请选择" style="width:100%">
								<el-option value="能源"></el-option>
								<el-option value="环境"></el-option>
								<el-option value="状态"></el-option>
							</el-select>

						</el-form-item> -->
						<el-form-item label="计量方式">
							<el-select size="small" v-model="jlEditParmater.meterWay" placeholder="请选择" style="width:100%">
								<el-option value="高供高计"></el-option>
								<el-option value="高供低计"></el-option>
								<el-option value="低供低计"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="计量点状态">

							<el-radio v-model="jlEditParmater.isRunning" :label="false">无效</el-radio>
							<el-radio v-model="jlEditParmater.isRunning" :label="true">有效</el-radio>
						</el-form-item>
						<!-- <el-form-item label="输入/输出用能">
							<el-radio v-model="jlEditParmater.inOrOut" label="输入">输入</el-radio>
							<el-radio v-model="jlEditParmater.inOrOut" label="输出">输出</el-radio>
						</el-form-item> -->
						<el-form-item label="能源种类" prop="energyType">
							<el-select size="small" v-model="jlEditParmater.energyType" placeholder="请选择"  style="width:100%" @change="editEnergyChange">
								<el-option
								  v-for="item in energyType" :key="item.value" :value="item.id" :label="item.value">
								</el-option>
							</el-select>

						</el-form-item>
						<el-form-item label="倍率" prop="magnification">
							<el-input size="small" v-model="jlEditParmater.magnification"></el-input>
						</el-form-item>


						<el-form-item label="表号" >
							<el-input size="small" v-model="jlEditParmater.meterNumber" placeholder="请输入表号"></el-input>
						</el-form-item>
            <el-form-item label="电能表类型">
            	<el-select size="small" v-model="jlEditParmater.be0800004" placeholder="请选择" style="width:100%">
            		<el-option label="单相电子表" value="01"></el-option>
                <el-option label="多功能表" value="02"></el-option>
                <el-option label="其他类型" value="03"></el-option>
            	</el-select>
            </el-form-item>
            <el-form-item label="租金" v-if="user.departmentId == 59 || user.departmentId == 6">
            		<el-input size="small" v-model="jlEditParmater.rent" placeholder="请输入租金"></el-input>
            </el-form-item>

					</el-col>
					<el-col :span="8">
						<el-form-item label="通讯方式" prop="communicationType">
							<el-select size="small" v-model="jlEditParmater.communicationType" placeholder="请选择" style="width:100%">
								<el-option
								  v-for="item in communicationTypeList" :key="item.value" :value="item.value">
								</el-option>
							</el-select>

						</el-form-item>
						<el-form-item label="通讯规约"  prop="communicationProtocol">
							<el-select size="small" v-model="jlEditParmater.communicationProtocol" placeholder="请选择" style="width:100%">
								<el-option
								  v-for="item in communicationProtocolList" :key="item.value" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="安装地点">

							<el-input size="small" v-model="jlEditParmater.installationSite" placeholder="请输入安装地点"></el-input>

						</el-form-item>

						<el-form-item label="采集终端" prop="terminalInfoIdStr">
							<el-select size="small" v-model="jlEditParmater.terminalInfoIdStr" placeholder="请选择" style="width:100%" filterable>
								<el-option
								  v-for="item in tetInfo" :key="item.id" :label="item.terminalName" :value="item.id">
								</el-option>
							</el-select>

						</el-form-item>
					<!-- 	<el-form-item label="采集数据项">
							<el-popover ref="popover" trigger="click" placement="right-start" >
							  <el-tree
							    :data="dataItemList"
								  show-checkbox
								  :props="{children: 'child',label:'itemName' }"
							    node-key="id"
							    ref="popupTree"
								  default-expand-all
							    @check-change="handleCheckChange"
							    :highlight-current="true"
								  :default-checked-keys="defaultItems"
							    :expand-on-click-node="true"
								  style="height: 300px; overflow-y: scroll; padding-right: 10px;"
								>
							  </el-tree>
							</el-popover>
							<el-input  v-model="showDataItemInfo" size="small" v-popover:popover :readonly="true" placeholder="点击选择" class="cp" ></el-input>

						</el-form-item>


						<el-form-item label="容量">
							<el-input size="small" v-model="jlEditParmater.capacity"></el-input>
						</el-form-item> -->

						<el-form-item label="终端内编码" prop="terminalNumber">
							<el-input size="small" v-model="jlEditParmater.terminalNumber"></el-input>
						</el-form-item>
						<el-form-item label="采集周期">
							<el-row >
								<el-col :span="10" style="padding-right: 10px;">
									<el-input-number  style="width: 100%;" controls-position="right" size="small" v-model="jlEditParmater.collectCycle" :min="1"  label="描述文字"></el-input-number>
									<!-- <el-input size="small" type="number"  v-model="jlEditParmater.collectCycle"></el-input> -->
								</el-col>
								<el-col :span="14">
									<el-select size="small" v-model="jlEditParmater.collectUnit" placeholder="请选择" style="width: 100%;">
										<el-option value="分钟"></el-option>
										<el-option value="小时"></el-option>
										<el-option value="日"></el-option>
										<el-option value="月"></el-option>
									</el-select>
								</el-col>
							</el-row>

						</el-form-item>
					<!-- 	<el-form-item label="是否直采">
							<el-radio v-model="jlEditParmater.isDirectCollect" :label="true">是</el-radio>
							<el-radio v-model="jlEditParmater.isDirectCollect" :label="false">否</el-radio>

						</el-form-item> -->

            <el-form-item label="计量点性质" >

            	<el-select size="small" v-model="jlEditParmater.be0800001" placeholder="请选择" style="width:100%">
            		<el-option
            		  v-for="item in meterProperties" :key="item.value" :value="item.value" :label="item.label">
            		</el-option>
            	</el-select>

            </el-form-item>
					<!-- 	<el-form-item label="通信端口号">
							<el-input size="small" v-model="jlEditParmater.communicationPortNumber"></el-input>
						</el-form-item>
 -->         <el-form-item label="数据位">
              <el-select v-model="jlEditParmater.be080000bdd" size="small" style="width: 100%;">
                <el-option label="5" value="05"></el-option>
                <el-option label="6" value="06"></el-option>
                <el-option label="7" value="07"></el-option>
                <el-option label="8" value="08"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="停止位">
              <el-select v-model="jlEditParmater.be080000bss" size="small" style="width: 100%;">
                <el-option label="1位" value="00"></el-option>
                <el-option label="1.5位" value="01"></el-option>
                <el-option label="2位" value="02"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="总分类型">
            	<el-select size="small" v-model="jlEditParmater.be0800005" placeholder="请选择" style="width:100%">
            		<el-option label="用户表" value="00"></el-option>
                <el-option label="总表" value="01"></el-option>

            	</el-select>
            </el-form-item>

					</el-col>
          <el-col :span="8">


            <el-form-item label="重点用户属性">
              <el-select size="small" v-model="jlEditParmater.be0800006" placeholder="请选择" style="width:100%">
            		<el-option label="普通用户" value="00"></el-option>
                <el-option label="重点用户" value="01"></el-option>

            	</el-select>
            </el-form-item>
            <el-form-item label="拉闸功能">
            	<el-select size="small" v-model="jlEditParmater.be0800007" placeholder="请选择" style="width:100%">
            		<el-option label="带拉闸" :value="true"></el-option>
            		<el-option label="不带拉闸" :value="false"></el-option>
            	</el-select>
            </el-form-item>
            <el-form-item label="拉闸密码">
              <el-input size="small" v-model="jlEditParmater.switchPassword" type="password"></el-input>
            </el-form-item>

            <el-form-item label="最大费率数">
              <el-input size="small" v-model="jlEditParmater.be0800008"></el-input>
            </el-form-item>
            <el-form-item label="计量点终端地址">
              <el-input size="small" v-model="jlEditParmater.be0800009" placeholder="计量点对应采集终端地址"></el-input>
            </el-form-item>
            <el-form-item label="波特率">
              <el-select size="small" v-model="jlEditParmater.be080000bbb" style="width: 100%;">
                <el-option label="2400" value="08"></el-option>
                <el-option label="1200" value="04"></el-option>
                <el-option label="600" value="02"></el-option>
                <el-option label="300" value="01"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="校验方式">
              <el-select v-model="jlEditParmater.be080000bpp" size="small" style="width: 100%;">
                <el-option label="无校验" value="00"></el-option>
                <el-option label="偶校验" value="01"></el-option>
                <el-option label="奇校验" value="02"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="ct变化">
              <el-input size="small" v-model="jlEditParmater.be080000c"></el-input>
            </el-form-item>
            <el-form-item label="pt变化">
              <el-input size="small" v-model="jlEditParmater.be080000d"></el-input>
            </el-form-item>
            <el-form-item label="是否预付费">
               <el-select v-model="jlEditParmater.isPay" size="small" style="width: 100%;" :disabled="isDisabled && (depId == 101||depId == 103)">
                 <el-option label="是" :value="true"></el-option>
                 <el-option label="否" :value="false"></el-option>

               </el-select>
             </el-form-item>

          </el-col>


        </el-row>

			</el-form>
			<div slot="footer"  class="dialog-footer">
				<el-button size="small" @click="deitJl = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleJlSave" :loading="loadSave">确 定</el-button>
			</div>
		</el-dialog>


		<el-row :gutter="12" >
			<el-col :span="5" class="silder-l" >
				<div class="m-left">
					<el-form class="user-search" label-width="68px" >
					  <el-form-item label="能源种类">
						 <el-select size="small" v-model="dataParameter.energyType" placeholder="请选择" >
							<el-option v-for="type in energyType" :label="type.value" :value="type.id" :key="type.value"></el-option>
						  </el-select>
					  </el-form-item>
            <el-form-item label="采集方案" v-if="user.name == 'admin'">
             <el-select size="small" v-model="dataSource" placeholder="请选择" @change="getJzData">
            	<el-option label="国网" value="1" ></el-option>
              <el-option label="南网" value="2" ></el-option>
             </el-select>
            </el-form-item>

					</el-form>
					<div>
						<el-tree
						:data="treeDaa"
						:expand-on-click-node="false"
						:highlight-current="true"
						@node-click="handleNodeClick"
						:props="jzProps"
						v-loading="depLoading"
						accordion
						node-key='id'
						>
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i v-if="!data.parentId && !data.isJz" class="el-icon-office-building" style="color: #fc910d;"></i>
									<i v-if="data.parentId" class="el-icon-location-outline"></i>
									<i v-if="data.isJz" class="el-icon-coin" style="color: #2ec7c9;"></i>
									{{ data.departmentName }}
								</span>

							</span>

						</el-tree>
					</div>
				</div>
			</el-col>

			<el-col :span="19"   >
				<div class="m-right">
					<!-- 计量点列表 -->
					<div class="data-list">
						<el-form :inline="true"  class="user-search" @submit.native.prevent>
						  <el-form-item label="搜索：">
						    <el-input size="small" style="width: 200px;" @keyup.enter.native="getData"  placeholder="请输入计量点名称" v-model="dataParameter.meterPointName"></el-input>
						  </el-form-item>
              <el-form-item >
                <el-input size="small" style="width: 200px;" @keyup.enter.native="getData"  placeholder="请输入计量点地址" v-model="dataParameter.meterPoint"></el-input>
              </el-form-item>
              <el-form-item >
                <el-select v-model="dataParameter.isRunning" clearable size="small" style="width: 140px;" placeholder="请选择状态">
                  <el-option label="运行中" :value="true"></el-option>
                  <el-option label="已停止" :value="false"></el-option>
                </el-select>
              </el-form-item>
						  <el-form-item>
						    <el-button size="small" type="primary" icon="el-icon-search" @click="handelSearch">搜索</el-button>
						  </el-form-item>
              <el-form-item>
                <prems-button size="small" type="primary" icon="el-icon-circle-plus-outline" perms="arc:add"  @click="addjl" label="添加" />
              </el-form-item>
              <el-form-item v-if="showZd">
                <!-- <prems-button size="small" type="primary" icon="el-icon-circle-plus-outline" perms="arc:add"  @click="addjl" label="" /> -->
                <el-button  v-if="!isNan"  :disabled="selectJl.length == 0" size="small" type="warning" perms="arc:xf"  @click="xiafa">下发</el-button>

                <el-button type="warning" :disabled="selectJl.length == 0" size="small" @click="jlZd">计量点参数召读</el-button>
              </el-form-item>
						   <el-form-item style="float: right;">
							 <el-upload
								action=""
								multiple
								:http-request="uploadFile"
								:show-file-list="false"
								:before-upload="beforeUpload"
							>

							  <prems-button size="small"  type="success" :loading="loadLoadin" icon="el-icon-upload2" label='导入'  perms="arc:import" />

							</el-upload>
						  </el-form-item>

              <el-form-item style="float: right;">
                 <el-button size="small"  type="success" icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">导出</el-button>
              </el-form-item>
						</el-form>


						<el-table   style="width: 100%;"  @selection-change="getSelectJl" size="small" border :data="jlData"  v-loading="loading" :max-height="tableHeight" :header-cell-style="this.$store.state.headerCss">

							<!-- <el-table-column align="center" type="selection" width="50">
							</el-table-column> -->
							<el-table-column type="selection" width="50"></el-table-column>
							<el-table-column label="计量点名称" prop="meterPointName"  show-overflow-tooltip></el-table-column>
							<el-table-column label="计量点地址" prop="meterPoint"  show-overflow-tooltip  width="140"></el-table-column>
              <el-table-column label="合同编号" prop="contractNo"  show-overflow-tooltip  width="80"></el-table-column>
							<el-table-column label="状态" width="70">
								<template slot-scope="scope">
									<div>
										<el-tag size="mini"  v-if="scope.row.isRunning" type="success">运行中</el-tag>
										<el-tag size="mini"  v-if="!scope.row.isRunning" type="info">已停止</el-tag>
									</div>
								</template>

							</el-table-column>

							<!-- <el-table-column label="采集周期" prop="collectCycle" width="80"  show-overflow-tooltip></el-table-column>
							<el-table-column label="采集单位" prop="collectUnit" show-overflow-tooltip  width="100" ></el-table-column> -->
               <el-table-column label="终端名称" prop="terminalInfoName" show-overflow-tooltip  ></el-table-column>
              <el-table-column label="终端内编码" prop="terminalNumber" show-overflow-tooltip  width="100" ></el-table-column>
              <el-table-column label="能源种类"   width="80">
              	<template slot-scope="scope">
              		<div>
              			<el-tag size="mini" type="warning" v-if="scope.row.energyType =='15' ">电</el-tag>
              			<el-tag size="mini" v-if="scope.row.energyType =='16'">水</el-tag>
                    <el-tag size="mini"  type="danger" v-if="scope.row.energyType =='18'">热能</el-tag>
              		</div>
              	</template>

              </el-table-column>
							<el-table-column label="操作" width="360" >
								<template slot-scope="scope">
									<!-- <prems-button size="mini" type="warning"  label='拉闸'  perms="arc:lz" /> -->
									<el-button size="mini" type="primary" @click="Jledit(scope.$index, scope.row)">详情</el-button>

									<prems-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)" label="删除" :loading="loadDel"  perms="arc:delete"/>
                  <template v-if="scope.row.energyType =='15' ">
                    <prems-button v-if="dataSource == '2'" size="mini" type="warning" @click="handSwitch(scope.row)" label="拉合闸"   perms="arc:lz"/>
                  </template>
				  <!-- <prems-button size="mini" type="success" @click="handleRefresh(scope.row)" label="刷新"   perms="arc:refreshStatus"/> -->

                  <prems-button size="mini" type="success" :loading="loadRefresh && cid == scope.row.id" label="刷新状态" perms="arc:refreshStatus"   @click="refreshStatus(scope.row)"></prems-button>
								</template>
							</el-table-column>
						</el-table>
						<!-- 分页组件 -->
						<Pagination v-bind:child-msg="pageparm"  v-if="showPage"  @callFather="callFather"></Pagination>
					</div>

				</div>

			</el-col>

		</el-row>


    <!-- 计量点参数召读结果 -->
    <el-dialog title="计量点参数召读结果" width="86%" :visible.sync="zdVisible" :close-on-click-modal="false">

      <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="exportZd" :loading="loadingExport">导出</el-button>
      <el-table   v-if="isNan == 1"  size="small" row-key="id" :data="zdList" :row-class-name="setYiChang" v-loading="loadingZd" border
        element-loading-text="拼命加载中" style="width: 100%;" :header-cell-style="this.$store.state.headerCss">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="测量点号" prop="terminalNumber">
        </el-table-column>
        <el-table-column label="测量点状态" prop="be0800000" width="84">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" v-if="scope.row.be0800000 == 1">有效</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.be0800000 == 0">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="建档状态" prop="meterPointStatus" width="80">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" v-if="scope.row.meterPointStatus == 1">正常</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.meterPointStatus == 2">异常</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="测量点性质" prop="be0800001">
        </el-table-column>
        <el-table-column label="表地址" prop="be0800002">
        </el-table-column>
        <el-table-column label="通讯规约" prop="be0800003">
        </el-table-column>
        <el-table-column label="表类型" prop="be0800004">
        </el-table-column>
        <el-table-column label="总分类型" prop="be0800005" width="100">
        </el-table-column>
        <el-table-column label="重点户属性" prop="be0800006" width="100">
        </el-table-column>
        <el-table-column label="拉闸功能" prop="be0800007">
        </el-table-column>
        <el-table-column label="费率数" prop="be0800008" width="70">
        </el-table-column>
        <el-table-column label="采集终端地址" prop="be0800009">
        </el-table-column>
        <el-table-column label="端口号" prop="be080000a" width="60">
        </el-table-column>
        <el-table-column label="波特率" prop="be080000bbb">
        </el-table-column>
        <el-table-column label="CT" prop="be080000c" width="50">
        </el-table-column>
        <el-table-column label="PT" prop="be080000d" width="50">
        </el-table-column>





        <!-- <el-table-column label="操作" width="240" align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="setGs(scope.row)">设置</el-button>
              <el-button size="mini" type="warning"  @click="handelDetail(scope.row)" >编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteGs(scope.row)">删除</el-button>
            </template>
          </el-table-column> -->
      </el-table>

      <el-table v-if="isNan == 0" size="small" :data="zdList" v-loading="loadingZd" border element-loading-text="拼命加载中"
        style="width: 100%;" :header-cell-style="this.$store.state.headerCss">
        <el-table-column label="测量点序号" prop="pointCode">
        </el-table-column>
        <el-table-column label="通信速率" prop="bpstype">
        </el-table-column>
        <el-table-column label="端口号" prop="comType">
        </el-table-column>
        <el-table-column label="表通信地址" prop="comaddr">
        </el-table-column>
        <el-table-column label="费率个数" prop="tarrif_num">
        </el-table-column>

        <el-table-column label="采集器通信地址" prop="comaddr_clc">
        </el-table-column>
        <el-table-column label="电能示值及小数位" prop="bitcount">
        </el-table-column>
        <el-table-column label="用户大类" prop="bigclass">
        </el-table-column>
        <el-table-column label="用户小类" prop="subclass">
        </el-table-column>


      </el-table>


      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="zdVisible = false">取 消</el-button>

      </div>
    </el-dialog>


    <el-dialog title="国网参数下发配置" width="50%" :visible.sync="setVisible" :close-on-click-modal="false">
         <el-form :inline="true" class="user-search" ref="setForm" :model="setForm" :rules="setRules">

           <el-form-item label="下发配置项:" prop="curRuleId">
             <el-select v-model="setForm.curRuleId" clearable size="small" placeholder="请选择配置" @change="changeGwRule">
               <el-option v-for="item in gwRules" :value="item.id" :label="item.ruleConfigName"></el-option>

             </el-select>
           </el-form-item>


         </el-form>

         <el-descriptions title="规则详情">
             <el-descriptions-item label="规则名称">{{gwForm.ruleConfigName}}</el-descriptions-item>
             <el-descriptions-item label="通信速率">{{getBps(gwForm.bps)}}</el-descriptions-item>
             <el-descriptions-item label="端口号">{{getCom(gwForm.com)}}</el-descriptions-item>
             <el-descriptions-item label="择通信协议">{{getPtypes(gwForm.protocol)}}</el-descriptions-item>
             <el-descriptions-item label="密码">{{gwForm.password}}</el-descriptions-item>
             <el-descriptions-item label="费率个数">{{gwForm.tarrif_num}}</el-descriptions-item>
             <el-descriptions-item label="采集通信地址">{{gwForm.comaddr_clc}}</el-descriptions-item>

             <el-descriptions-item label="电能示值及小位数">{{gwForm.bitcount}}</el-descriptions-item>
             <el-descriptions-item label="用户大类">{{gwForm.bigclass}}</el-descriptions-item>
             <el-descriptions-item label="用户小类">{{gwForm.subclass}}</el-descriptions-item>
             <el-descriptions-item label="有功电能示值的整数位个数">{{gwForm.intSum}}</el-descriptions-item>
             <el-descriptions-item label="有功电能示值的小数位个数">{{gwForm.decimalSum}}</el-descriptions-item>
         </el-descriptions>


         <div slot="footer" class="dialog-footer">
           <el-button size="mini" type="primary" @click="saveSet" :loading="loadXiaFa">确定</el-button>
           <el-button size="mini" @click="setVisible = false">取消</el-button>
         </div>
       </el-dialog>

	</div>
</template>

<script>
	import PremsButton from "@/views/permission/PreButtom";
	import { provinceAndCityData,CodeToText } from 'element-china-area-data'
	import Pagination from '../../components/Pagination'



	import {
	 findMeterInfoList,
	 getDepartmentTerminalInfoLis,
	 getTerminalInfoByDepId,
	 deleteMeterInfo,
	 getAllConfigurationList,
	 getAllDataItemList,
	 getTerminalInfoListByAddMeterInfo,
	 addMeterInfo,
	 updateMeterInfo,
	 uploadjl,
	 getRoomList,
   CheckSwitchAdmin,
   getSwitch,
   getSwitchNew,
   findMeterInfoPoiFiter,
   getMeterPointParam,
   getMeterPointParamPoi,
   getMeterGWPointParam,
   ifGWOrNW,
   findAllGWRuleConfig,
   findPointAddrByGWConfig,
   queryMeterStatus,
	} from '../../api/energyMG'
	export default{
		data(){
			return{
        selectJz:false,
        zdVisible:false,
        isCheck:false,
        loadDel:false,
        gVisible:false,
        isRun:false,
				canGetRoom:false,
        loadSwitch:false,
				options: provinceAndCityData,
				selectedOptions: [],
				suoshu:'',
        user:{},
				formInline:{
					type:""
				},
        isNan:1,
        downloadLoadin:false,
        checkForm:{
          username:"",
          password:""
        },
         gwRules:[],
        setVisible:false,
        mName:"",
        switchForm:{
          id:"",
          rtuAddr:"",
          meterAddr:"",
          passWord:"",
          switchType:"2",

        },
        cid:"",
        zdList:[],
        loadingZd:false,
        showZd:false,
        selectJl:[],
        dataSource:'2',
				upHeader:{
					'Content-Type': 'multipart/form-data'
				},
				depLoading:true,
				nyTitle:'新增用能单位',
				type:'电力',
				jieDianTitle:'新增节点',
				jieDianVisible:false,//新增、编辑节点对话框
				editFormVisible:false,//编辑公式对话框
				editNyuanFromVisible:false,//能源分类对话框
				deitJl:false,
        tableHeight: 0,
				defaultProps:{
					children: 'option',
					label: 'type'
				},
        loadingExport:false,

        gwForm:{
          "ruleConfigName": "",
            "com": '',
            "protocol": '',
            "password": "",
            "tarrif_num": '',
            "comaddr_clc": "",
            "bitcount": '',
            "bigclass": '',
            "subclass": '',
            "intSum": '',
            "decimalSum": '',
            "bps": ''
        },
				jdType:'用能单位',
        sRules:{
          passWord:[
            {required:true,message:'请输入密码',trigger: 'blur'}
          ]
        },
        cRules:{
          username:[{required:true,message:"请输入管理员账号",trigger:'blur'}],
          password:[{required:true,message:'请输入管理员密码',trigger:'blur'}]
        },

				 rules: {
					 meterPointName:[
						{ required: true, message: '请输入计量电名称', trigger: 'blur' },
					 ],
					 be0800001:[
					 	{ required: true, message: '请选择计量点性质', trigger: 'change' },
					 ],
					 meterPoint:[
					 	{ required: true, message: '请输入计量电通讯地址', trigger: 'blur' },
					 ],
           contractNo:[
           	{ required: true, message: '请输入合同编号', trigger: 'blur' },
           ],

					 meterType:[
					 	{ required: true, message: '请选择计量点类别', trigger: 'change' },
					 ],
					 magnification:[
					 	{ required: true, message: '请输入倍率', trigger: 'blur' },
					 ],
					 terminalInfoIdStr:[
					 	{ required: true, message: '请选择采集终端', trigger: 'change' },
					 ],
           communicationProtocol:[
           	{ required: true, message: '请选择通信规约', trigger: 'change' },
           ],
					 terminalNumber:[
						 { required: true, message: '请输入终端内编码', trigger: 'blur' },
					 ],
					 energyType:[
						 { required: true, message: '请选择能源种类', trigger: 'change' },
					 ],
					 meterNumber:[
						 { required: true, message: '请输入表号', trigger: 'change' },
					 ],
           communicationType:[
             {required:true,message:'请选择通讯方式',trigger:"blur"}
           ]

				 },
         setRules: {
           curRuleId: [{
             required: true,
             message: "请选择配置项",
             trigger: "change"
           }]
         },

				//查询参数
				dataParameter:{
					terIds:JSON.stringify([]),
					currentPage: 1,
					pageSize: 10,
					meterPoint:'',
					meterPointName:'',
					energyType:'',
          isRunning:'',
				},
        switchVisible:false,
        isHaveWater:false,
        setForm:{
          curRuleId:"",
        },
        loadRefresh:false,
				jlEditParmater:{
          rent:0,//59深圳市盛鸿鑫物业有限公司租金
           contractNo:"",//合同编号
          abc:'01',
					meterPoint:"",
					meterPointName:"",
					meterProperties:"",//计量点性质 改为be0800001
					isRunning:true,
					meterType:"",
					inOrOut:"输入",
					energyType:"",
					magnification:"",
					meterWay:"",
					installationSite:"",
					dataItem:"",
					dataItemList:[],
					capacity:"",
					isDirectCollect:true,
					collectCycle:"",
					collectUnit:"小时",
					terminalNumber:"",
					communicationType:"",
					communicationProtocol:"",

					terminalInfoIdStr:"",
					communicationRate:"",//通信速率
					communicationPortNumber:"", //通信端口号
					meterNumber:'',//表号
					roomId:'',
          switchPassword:"",//拉闸密码
          be0800007:true, //拉闸功能
          be0800001:"",//计量点性质
          be0800004:'',//电能表类型
          be0800005:"",//总分类型
          be0800006:"",//重点用户类型
          be0800008:"",//最大费率数
          be0800009:"000000000000",//测量点对应采集终端地址
          be080000bbb:"",//BB：通信波特率
          be080000bpp:"",//PP：校验方式,
          be080000bdd:"",//DD：数据位
          be080000bss:"",//SS：停止位
          be080000c:"",//CT 变比
          be080000d:"",//PT 变比
          be0800010:"",//测量点接线方式
          be0800011:"",//额定电压
          be0800012:"",//额定电流
          be0800013:"",//用户申报容量
          be0800014:"",//变压器容量
          be0800021:"",//电能表通信密
          be0800022:"",//电能表通信用户名
          isPay:true //是否预付费

				},
        loadSave:false,
				dataItemList:[

				],
        loadXiaFa:false,
				showDataItemInfo:"",
        ptypes:[
          { label:'DLT645_1997', value:1},
          { label:'DLT645_AcSamplingUnit', value:2},
          { label:'DLT645_2007', value:30},
          { label:'DLT645_WaterPowerNaturalGas', value:32},
        ],
				meterProperties:[
					{label:'485表', value:"01"},
          {label:'模拟量表', value:"02"},
          {label:'脉冲量', value:"03"},
          {label:'计算值', value:"04"},
          {label:'交流采样' ,value:"05"},

				],
				energyType:[],
				roomList:[],
        commAddress:"",
				communicationProtocolList:[],//规约类型集合
				communicationTypeList:[], //通讯方式
				loading:true,

				 // 分页参数
				pageparm: {
				  currentPage: 1,
				  pageSize: 10,
				  total: 0
				},
        showPage:true,

				terIds:{},
				currtypeId:0,
				meterInfo:{},
				tetInfo:[],//集中器数据

				treeDaa: [],
				loadLoadin:false,
				defaultItems:[],
				jzProps:{
					label: function( data,node ){
						console.log(data)
					},
					children: 'deps',

				},
				jltitle:'',
				jlData:[],
        bpsList:[
           { label: 'bps_600', value:1 },
           { label: 'bps_1200', value:2 },
           { label: 'bps_2400', value:3 },
           { label: 'bps_4800', value:4 },
           { label: 'bps_7200', value:5 },
           { label: 'bps_9600', value:6 },
           { label: 'bps_19200', value:7 },
        ],

        comList:[
          { label:'com_485_1', value:2},
          { label:'com_485_2', value:3},
          { label:'com_485_3', value:4},
          { label:'com_485_4', value:5},
          { label:'com_485_5', value:6},
          { label:'com_485_6', value:7},
          { label:'com_485_7', value:8},
          { label:'com_485_8', value:9},
          { label:'com_485_9' ,value :10},
          { label:'com_485_10',value :11},
          { label:'com_485_11',value :12},
          { label:'com_485_12',value :13},
          { label:'com_485_13',value :14},
          { label:'com_485_14',value :15},
          { label:'com_485_15',value :16},
          { label:'com_485_16',value :17},
          { label:'com_485_17',value :18},
          { label:'com_485_18',value :19},
          { label:'com_485_19',value :20},
          { label:'com_485_20',value :21},
          { label:'com_485_21',value :22},
          { label:'com_485_22',value :23},
          { label:'com_485_23',value :24},
          { label:'com_485_24',value :25},
          { label:'com_485_25',value :26},
          { label:'com_485_26',value :27},
          { label:'com_485_27',value :28},
          { label:'com_485_28',value :29},
          { label:'com_485_29',value :30},
          { label:'com_485_30',value :31},
        ],
		isDisabled :false,
		depId:'',

			}
		},

    mounted(){
      this.$nextTick(() => {

      	this.tableHeight = window.innerHeight - 260
      })
    },
		created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
	  this.depId = this.user.departmentId
      console.log(this.user,'this.depId',this.depId)
			this.choiseOpeion = ''
			this.getJzData();
			this.getConfigData();

			this.getTerInfo();
      this.getGwRules()
			//this.$store.dispatch('getDepts')

		},
		 // 注册组件
		components: {
		  Pagination,
		  PremsButton
		},

		computed:{

		},


		methods:{
			// 2023-1-29 刷新
			handleRefresh(row){

			},
      setYiChang({row,rowIndex}){
        console.log(row.meterPointStatus)
        if(row.meterPointStatus == 2){
          return 'warning-row'
        }

      },

     getSelectJl(data) {
       this.selectJl = data

       this.isHaveWater = false
       this.selectJl.forEach( item => {
         if(item.energyType == '16'){
           this.isHaveWater = true
         }
       })
     },
     changeGwRule(e){
       this.gwForm = this.gwRules.filter(item => item.id == e)[0]
     },
     getGwRules(){
       let param = {
         ruleConfigName:"",
         currentPage:'1',
         pageSize:'999999',

       }
       findAllGWRuleConfig(param).then(res => {
         this.loading = false
         if (res.status == 1) {
           this.gwRules = res.data.content

         }
       })
     },
     getBps(val){
       let data = this.bpsList.filter(item => item.value == val)[0]
       if(data){
         return data.label
       }
     },

     xiafa(){

       if(this.isHaveWater){
         this.$message.warning('水表暂时不能下发哦~')
         return
       }
       if(this.selectJl.length > 8){
         this.$message.warning('参数下发数量不能超过8个~~')
         return
       }
       this.setVisible  = true
     },
     getCom(val){
       let data = this.comList.filter(item => item.value == val)[0]
       if(data){
         return data.label
       }
     },
     getPtypes(val){
       let data = this.ptypes.filter(item => item.value == val)[0]
       if(data){
         return data.label
       }
     },


      exportZd(){
        this.loadingExport = true
        let param = {
          commAddress:this.commAddress,
          pnList:this.selectJl.map(item => item.terminalNumber).join(',')
        }
        getMeterPointParamPoi(param).then(res => {
          this.loadingExport = false
          var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
          	var downloadElement = document.createElement('a');
          　　var href = window.URL.createObjectURL(blob); //创建下载的链接
          　　downloadElement.href = href;
          　　downloadElement.download = 'result.xls'; //下载后文件名
          　　document.body.appendChild(downloadElement);
          　　downloadElement.click(); //点击下载
          　　document.body.removeChild(downloadElement); //下载完成移除元素
          　　window.URL.revokeObjectURL(href); //释放掉blob对象
          	this.downloadLoadin = false
          	this.$message.success('表格生成成功！正在下载')
          }).catch(err => {
          	this.downloadLoadin = false
          	this.$message({
          		message:'下载失败！',
          		type:'error',
          		showClose:true
          	})
          })

      },

      jlZd() {
        if(this.isHaveWater){
          this.$message.warning('水表不能进行召读哦~~')
          return
        }

        if(this.selectJl.length > 10){
          this.$message.warning('计量点参数召读数量不能超过10个~~')
          return
        }
        this.zdVisible = true
        let param = {
          commAddress: this.commAddress,
          pnList: this.selectJl.map(item => item.terminalNumber)
        }

        this.loadingZd = true
        getMeterGWPointParam(param).then(res => {
          this.loadingZd = false
          if (res.status == 1) {
            this.zdList = res.data
          }else{
            this.$message.error(res.msg)
            this.zdList = []
          }
        })
      },

      exportdata(){
      	this.downloadLoadin = true

        let param = {
          terIds:this.dataParameter.terIds,
          meterPoint:this.dataParameter.meterPoint,
          meterPointName:this.dataParameter.meterPointName,
          energyType:this.dataParameter.energyType,
          isRunning:this.dataParameter.isRunning,
        }


      	findMeterInfoPoiFiter(param).then(res => {

      		var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
      		var downloadElement = document.createElement('a');
      	　　var href = window.URL.createObjectURL(blob); //创建下载的链接
      	　　downloadElement.href = href;
      	　　downloadElement.download = 'result.xls'; //下载后文件名
      	　　document.body.appendChild(downloadElement);
      	　　downloadElement.click(); //点击下载
      	　　document.body.removeChild(downloadElement); //下载完成移除元素
      	　　window.URL.revokeObjectURL(href); //释放掉blob对象
      		this.downloadLoadin = false
      		this.$message.success('表格生成成功！正在下载')
      	}).catch(err => {
      		this.downloadLoadin = false
      		this.$message({
      			message:'下载失败！',
      			type:'error',
      			showClose:true
      		})
      	})

      },
      handelSearch(){
        this.dataParameter.currentPage = 1
        this.showPage = false
        this.getData()
        this.$nextTick(()=>{
          this.showPage = true
        })


      },

      handSwitch(row){

        if(this.isCheck){
          this.switchVisible = true
        }else{
          this.gVisible = true
        }



        this.$nextTick(()=>{
         this.$refs.geditForm.clearValidate()
        })
        this.switchForm.rtuAddr = row.terminalCode
        this.switchForm.meterAddr = row.meterPoint

         this.switchForm.id = row.id
        this.switchForm.passWord = '',
        this.switchForm.switchType = row.isRunning ? '1':'2'
        this.mName = '('+row.meterPointName+')'
        this.isRun = row.isRunning
      },

      checkSwitch(){
        this.$refs['geditForm'].validate( val =>{
          CheckSwitchAdmin(this.checkForm).then(res => {
            if(res.status == 1){
              this.switchVisible = true
              this.gVisible = false
              this.isCheck = true

            }else{
              this.$message.error(res.msg)
            }
          })
        })
      },

      //刷新状态
      refreshStatus(row){
        this.loadRefresh = true
        this.cid = row.id
        queryMeterStatus({id:row.id}).then(res => {
           this.loadRefresh = false
           if(res.status == 1){
             this.$message.success(res.msg)
             this.getData()
           }else{
             this.$message.error(res.msg)
           }
        })
      },



      //拉合闸
      saveSwitch(){
        this.$refs['seditForm'].validate((valid) => {
          if(valid){
            this.$confirm('确定进行此操作吗?', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(()=>{
              this.loadSwitch = true



              getSwitchNew(this.switchForm).then(res => {
                this.loadSwitch = false
                if(res.status == 1){
                  this.$message.success('操作成功！')
                  this.switchVisible = false
                   this.getData()
                }else{
                  this.$message.error(res.msg)
                }
              })
            })
          }
        });



      },


			//获取所有配置选项
			getConfigData(){
				getAllConfigurationList().then(res => {
					if(res.status == 1){

						this.energyType = res.data.energyType
						this.communicationProtocolList = res.data.communicationProtocol
						this.communicationTypeList = res.data.communicationType
						let currtypeId = res.data.energyType.filter( item => item.value == '电力')[0].id
						this.jlEditParmater.energyType = currtypeId
						return currtypeId
					}else{
						this.$message.error(res.msg)
					}
				}).then( typeId =>{
					this.getDataItemList(typeId);
				})

			},
			//添加计量点时获取集中器列表
			getTerInfo(){
				getTerminalInfoListByAddMeterInfo().then(res => {
					if(res.status == 1){
						this.tetInfo = res.data
					}else{
						this.$message.error(res.msg)
					}
				})
			},

			//添加计量点
			addMeter(){
        this.loadSave = true
				addMeterInfo(this.jlEditParmater).then(res => {
           this.loadSave = false
					if(res.status == 1){
						this.$message.success('添加成功！')
						this.getData();
						this.deitJl = false
					}else{
						this.$message.error(res.msg)
						//this.deitJl = false
					}
				})
			},
			beforeUpload (file) {

				  const isText = file.type === 'application/vnd.ms-excel'
				  const isTextComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				  return (isText | isTextComputer)
			},

			//导入
			uploadFile(val){
				this.loadLoadin = true

				let  formData = new FormData();
                formData.append('file', val.file);

				uploadjl(formData).then(res => {
					this.loadLoadin = false
					if(res.status == 1){
						this.$message.success(res.msg)
						this.getJzData();
					}else{
						this.$message.error(res.msg)
					}
				})
			},


			//修改计量点
			updataMeter:function(){
        this.loadSave = true
				updateMeterInfo(this.jlEditParmater).then( res => {
          this.loadSave = false
					if(res.status == 1){
						this.$message.success('修改成功！')
						this.deitJl = false
						this.getData();
					}else{
						this.$message.error(res.msg)
						//this.deitJl = false
					}
				})
			},
			getDataItemList:function(eType){

				getAllDataItemList({energyType:eType}).then(res =>{
					if(res.status == 1){
						this.dataItemList = res.data.treeList
						this.defaultItems = res.data.ids
						this.showDataItemInfo = '共'+ res.data.ids.length+'项数据，点击查看'

						this.jlEditParmater.dataItem = this.defaultItems.join('-')
					}
				})
			},

			handleCheckChange:function(data,checked){
				let arr = this.$refs.popupTree.getCheckedKeys()
				this.jlEditParmater.dataItem = arr.join('-')
				this.showDataItemInfo = '共'+ arr.length+'项数据，点击查看'
			},
			handleNodeClick(data){
        console.log(data,"烦死的data");
        this.dataParameter.currentPage = 1
        this.showPage = false
		// this.depId = data.id
				if(data.isJz){
					let idstr = JSON.stringify([{id:data.id}])
					this.dataParameter.terIds = idstr
          this.showZd = true
          this.commAddress = data.terminalCode
					this.getData();
          this.getProtoType()
          this.selectJz = true
          this.jlEditParmater.terminalInfoIdStr = data.id



				}else{
          this.jlEditParmater.terminalInfoIdStr = ''
          this.selectJz = false
          this.showZd = false
					//点击部门获得集中器id
					getTerminalInfoByDepId({depId:data.id}).then(res => {
						if(res.status == 1){
							let arr = []
							res.data.forEach( item => {
								let obj = {}
								obj.id = item
								arr.push(obj)
							})

							if(arr.length){
								this.dataParameter.terIds = JSON.stringify(arr)
							}else{
								//解决bug 如果获得的集中器是个空数组 查询数据将会是所有的数据 ，所以这个时候 给个不存在 的id
								this.dataParameter.terIds = JSON.stringify([{id:0}])
							}
							this.getData();
						}else{
							this.$message.error(res.msg)
						}
					})
				}
        this.$nextTick(()=>{
          this.showPage = true
        })

			},

			handleDel( idx,row){
				 this.$confirm('确定要删除吗?', '信息', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
          this.loadDel = true
					deleteMeterInfo({id:row.id}).then(res => {
             this.loadDel = false
						if(res.status == 1){
							this.$message.success('删除成功！')
							this.getData()
						}else{
							this.$message.error(res.msg)
						}
					})
				})
			},

			Jledit(idx,row){
				this.deitJl = true
				this.jltitle = "计量点详情"
				this.isDisabled = true;
        this.$nextTick(()=>{
           this.$refs['editForm'].clearValidate()
        })

        this.jlEditParmater.rent = row.rent || 0
				this.jlEditParmater.id = row.id || ""
        this.jlEditParmater.contractNo = row.contractNo || ""
				this.jlEditParmater.meterPoint = row.meterPoint || ""
				this.jlEditParmater.meterPointName = row.meterPointName || ""
				this.jlEditParmater.meterProperties = row.meterProperties || ""
				this.jlEditParmater.isRunning = row.isRunning
				this.jlEditParmater.meterType = row.meterType || ""
				this.jlEditParmater.inOrOut = row.inOrOut || ""
				this.jlEditParmater.energyType  =  parseInt(row.energyType)  || ""
				this.jlEditParmater.magnification  = row.magnification || ""
				this.jlEditParmater.meterWay  = row.meterWay || ""
				this.jlEditParmater.installationSite  = row.installationSite || ""
				this.jlEditParmater.dataItem  = row.dataItem || ""
				this.jlEditParmater.dataItemList  = row.dataItemList || ""
				this.jlEditParmater.capacity  = row.capacity || ""
				this.jlEditParmater.isDirectCollect =   row.isDirectCollect || ""
				this.jlEditParmater.collectCycle  = row.collectCycle || ""
				this.jlEditParmater.collectUnit =   row.collectUnit || ""
				this.jlEditParmater.terminalNumber  = row.terminalNumber || ""
				//this.jlEditParmater.terminalAddress  = row.terminalAddress
				this.jlEditParmater.communicationType  = row.communicationType || ""
				this.jlEditParmater.communicationProtocol  = row.communicationProtocol || ""

				this.jlEditParmater.terminalInfoIdStr  = row.terminalInfoId || ""
				this.jlEditParmater.communicationRate  = row.communicationRate || ""
				this.jlEditParmater.communicationPortNumber  = row.communicationPortNumber || ""
				this.jlEditParmater.meterNumber  = row.meterNumber || ""


        this.jlEditParmater.be0800007  = row.be0800007 || ""
        this.jlEditParmater.be0800001  = row.be0800001 || ""
        this.jlEditParmater.be0800004  = row.be0800004 || ''
        this.jlEditParmater.be0800005  = row.be0800005 || ""
        this.jlEditParmater.be0800006  = row.be0800006 || ""
        this.jlEditParmater.be0800008  = row.be0800008 || ""
        this.jlEditParmater.be0800009  = row.be0800009 || ""
        this.jlEditParmater.be080000bbb = row.be080000bbb || ""
        this.jlEditParmater.be080000bpp = row.be080000bpp || ""
        this.jlEditParmater.be080000bdd = row.be080000bdd || ""
        this.jlEditParmater.be080000bss = row.be080000bss || ""
        this.jlEditParmater.be080000c = row.be080000c || ""
        this.jlEditParmater.be080000d = row.be080000d || ""
        this.jlEditParmater.be0800010 = row.be0800010 || ""
        this.jlEditParmater.be0800011 = row.be0800011 || ""
        this.jlEditParmater.be0800012 = row.be0800012 || ""
        this.jlEditParmater.be0800013 = row.be0800013 || ""
        this.jlEditParmater.be0800014 = row.be0800014 || ""
        this.jlEditParmater.be0800021 = row.be0800021 || ""
        this.jlEditParmater.be0800022 = row.be0800022 || ""
        this.jlEditParmater.switchPassword = row.switchPassword || ""
        this.jlEditParmater.isPay = row.isPay || false
        this.getDataItemList(row.energyType);
				// this.jlEditParmater.roomId  = row.roomList[0].id || ""

				// this.selectedOptions = [ row.roomList[0].provinceId+'',row.roomList[0].cityId+''] || ""

				// let param = {
				// 	province : CodeToText[row.roomList[0].provinceId],
				// 	city     : CodeToText[row.roomList[0].cityId]
				// }


				// this.getroom(param)



			},
      getProtoType() {
        ifGWOrNW({
          rtuAddr: this.commAddress
        }).then(res => {
          if (res.status == 1) {
            this.isNan = res.data.protocolType
          }
        })
      },
      saveSet() {
        this.$refs['setForm'].validate(val => {
          if (val) {
            let param = {
              protocolType: this.isNan,
              ruleConfigNo: this.setForm.curRuleId,
              rtuAddr: this.commAddress,
              pnList: this.selectJl.map(item => item.id)
            }
            this.loadXiaFa = true
            findPointAddrByGWConfig(param).then(res => {
              this.loadXiaFa = false
              if (res.status == 1) {
                this.$message.success(res.data.pnValueMap[0].dataList[0].simpleStringValue)
                this.setVisible = false
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })

      },

			addjl(){
				this.deitJl = true
				this.isDisabled = false;
        this.$nextTick(()=>{
           this.$refs['editForm'].clearValidate()
        })
				this.jltitle = '新增计量点'
        this.jlEditParmater.isPay = false,
        this.jlEditParmater.rent = 0
        this.jlEditParmater.id = ""
				this.jlEditParmater.meterPoint=""
				this.jlEditParmater.meterPointName=""
				this.jlEditParmater.meterProperties=""
				this.jlEditParmater.isRunning = true
				this.jlEditParmater.meterType=""
				this.jlEditParmater.inOrOut="输入"
				this.jlEditParmater.energyType =""
				this.jlEditParmater.magnification =""
				this.jlEditParmater.meterWay =""
				this.jlEditParmater.installationSite =""
				this.jlEditParmater.dataItem =""
				this.jlEditParmater.dataItemList =[]
				this.jlEditParmater.capacity =""
				this.jlEditParmater.isDirectCollect = true
				this.jlEditParmater.collectCycle =""
				this.jlEditParmater.collectUnit = "小时"
				this.jlEditParmater.terminalNumber =""
				//this.jlEditParmater.terminalAddress =""
				this.jlEditParmater.communicationType =""
				this.jlEditParmater.communicationProtocol =""
				this.jlEditParmater.terminalInfoIdStr = this.selectJz ? this.jlEditParmater.terminalInfoIdStr:''
				this.jlEditParmater.communicationRate =""//通信速
				this.jlEditParmater.communicationPortNumber =""
				this.jlEditParmater.meterNumber = ""
				this.jlEditParmater.roomId = ""
        this.jlEditParmater.contractNo = ''

        this.jlEditParmater.be0800007  =  true
        this.jlEditParmater.switchPassword  =  ""
        this.jlEditParmater.be0800001  =  "01"
        this.jlEditParmater.be0800004  =  '01'
        this.jlEditParmater.be0800005  =  "00"
        this.jlEditParmater.be0800006  =  "00"
        this.jlEditParmater.be0800008  =  "04"
        this.jlEditParmater.be0800009  =  "000000000000"
        this.jlEditParmater.be080000bbb =  "08"
        this.jlEditParmater.be080000bpp =  "01"
        this.jlEditParmater.be080000bdd =  "08"
        this.jlEditParmater.be080000bss =  "00"
        this.jlEditParmater.be080000c =  "0001"
        this.jlEditParmater.be080000d =  "0001"
        this.jlEditParmater.be0800010 =  ""
        this.jlEditParmater.be0800011 =  ""
        this.jlEditParmater.be0800012 =  ""
        this.jlEditParmater.be0800013 =  ""
        this.jlEditParmater.be0800014 =  ""
        this.jlEditParmater.be0800021 =  ""
        this.jlEditParmater.be0800022 =  ""


			},
			editEnergyChange(data){
				this.getDataItemList(data)
			},
			handleJlSave(idx,row){
				this.$refs['editForm'].validate((valid) => {
				  if (valid) {
						if(this.jltitle == '新增计量点'){
							this.addMeter();
						}else{
							this.updataMeter();
						}

				  } else {

						return false;
				  }
				});
			},

			append(data){
				this.editFormVisible = true
			},
			//获取数据
			getJzData(){
				this.depLoading = true;
        let param = {
          dataSource:this.dataSource
        }
				getDepartmentTerminalInfoLis(param).then(res => {
					if(res.status == 1){
						//数据改造
						this.treeDaa = this.chagenData(res.data.menuDepList)
						this.depLoading = false;
						return res.data.terIds
					}else{
						this.$message.error(res.data.msg)
					}
				}).then( res => {
					let arr = []
					res.forEach( item => {
						arr.push({ id: item})
					})
					this.dataParameter.terIds = JSON.stringify(arr)
					this.getData();
				})
			},


			chagenData( data ){
				data.forEach(item =>{
					if( item.terminalInfo){
						if(!item.deps){
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz= true
							item.deps.push(obj)
						})
					}

					if( item.deps){
						this.chagenData(item.deps)
					}
				})

				return  data
			},
			handleChange(e){
				let param = {
					province : CodeToText[e[0]],
					city     : CodeToText[e[1]]
				}
				this.getroom(param)
			},

			getroom(param){
				getRoomList(param).then( res =>{
					if(res.status == 1){
						this.canGetRoom = true

						this.roomList = res.data
					}
				})
			},
			getData(){
				this.loading = true

				findMeterInfoList(this.dataParameter).then(res => {
					if(res.status == 1){
						this.loading = false
						this.jlData = res.data.data

						// 分页赋值
						this.pageparm.currentPage = this.dataParameter.currentPage
						this.pageparm.pageSize = this.dataParameter.pageSize

						this.pageparm.total = res.data.totalCount
					}else{
						this.loading = false
						this.$message.error(res.msg)
					}
				})
				.catch( err =>{
					this.loading = false
					this.$message.error(err)
				})
			},
			// 分页插件事件
			callFather(parm) {

			  this.dataParameter.currentPage = parm.currentPage
			  this.dataParameter.pageSize = parm.pageSize
			  this.getData()
			},


			renderContent(h, { node, data, store }) {
				// let title = ''
				// if( node.childNodes.length ){
				// 	return (
				// 	  <span class="custom-tree-node">
				// 		<span>{node.label}</span>
				// 		<span class="t-title">( 能源种类 )</span>

				// 	  </span>);
				// }else{
				// 	return (
				// 	  <span class="custom-tree-node">

				// 			<span>{node.label}</span>
				// 			<span class="t-title"> ( 能源分项 )</span>
				// 			<el-button size="mini" type="text" on-click={ () => this.append(data) } style="padding-left:60px" >编辑公式</el-button>


				// 	  </span>);
				// }

			}
		}

	}
</script>

<style scoped>

  .yi-chang{
     color: #F56C6C;
  }
  .warning-row{
    color: #F56C6C;
  }

	.container{
		height: 100%;

	}

	.nybox{

		margin-top: 10px;
		padding:0 20px;
	}

	.demo-table-expand .el-form-item__content {
		line-height: 30px;
		font-size: 13px;
	}
	.demo-table-expand .el-form-item__label{
		font-size: 13px;
		line-height: 30px;
	}
	.cp .el-input__inner{
		cursor: pointer;
	}

	.el-table__expanded-cell[class*=cell]{
		padding: 10px 30px;
	}

	.m-left,.m-right{
		background: #fff;
		padding: 20px;
		height: 100%;

	}
	.m-right{

		padding:0 20px;

	}

	.el-tree-node__content{
		line-height: 40px;
	}

	.el-tree-node{
		margin: 10px 0;
	}
	.data-list{
		padding-top: 20px;
	}

	.silder-l{
		height: 100%;
		border-right: 4px solid #f4f4f4;
	}
	.m-left .el-tree{
		font-size: 13px;
	}
	.m-left .el-tree i{
		font-size: 14px;
	}
	.m-left /deep/ .el-tree-node{
		white-space: normal !important;
	}
	.m-left /deep/ .el-tree-node__content{
		height: auto;
		padding: 6px 0;
	}


	.el-tree{
		border-radius: 6px;

	}
	.t-title{
		color: #ccc;
		font-size: 12px;
		padding-left: 10px;
	}
	.el-textarea__inner{
		height: 80px;

	}
	.el-textarea.is-disabled .el-textarea__inner{
		color: #666;
	}
	.data-list{
		height: 100%;
	}
	.demo-table-expand .el-form-item{
		margin-bottom: 0px;
	}

	.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
		background-color: #8fc6ff;
		color: #fff;
	}
	.el-form-item {
		margin-bottom: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/views/archives/structure.vue